angular.module('jv.Candidate.ProfileHistory.controller', ['jv.Common.Constants.Dates'])
    .controller('jvCandidateProfileHistoryController', [
        '$scope', '$rootScope', '$timeout', '$window', 'jvCandidateProfileFactory','months','years','$routeParams',
        /*
            Note : Broadcast events to fetch workhistory/education data:
            profileHistoryController handles the get/post of profile history data. Other controllers broadcast evets with callbacks that profileHistoryController listens to to fetch profile data.
            jv.cand.details will broadcast getProfileHistory to fetch data when you are not on summary tab and you refresh the page. Summary controller is not called at that time.
            jv.summary.summary.details will broadcast getProfileHistory to fetch data when you are on summary tab and you refresh the page or if you come from a different tab to summary tab. In both cases summary controller is called
        */
        function($scope, $rootScope, $timeout, $window, jvCandidateProfileFactory,months,years, $routeParams) {
            var profileFactory  = jvCandidateProfileFactory;

            //set edit mode to false on load
            $scope.educationEditMode = false;
            $scope.workEditMode = false;
            $scope.workHistoryData = '';
            $scope.educationHistoryData = '';
            //nav away warning
            $window.onbeforeunload= function(){
                if($scope.workEditMode || $scope.addWorkHistory || $scope.educationEditMode || $scope.addEducationHistory){
                    return $scope.i18n.NAV_AWAY_WARNING_MESSAGE;
                }
            };
            
            //flag used to enable/disable edit on work History / education
            $scope.canEditProfile = $scope.perms.APPLICATION_APPLICATIONS_DETAILS_EDIT_POST || false;

            //event handler to load the workHistory data for read only view
            var renderProfileHistoryData = function(data){
                if(data && (data.workHistory || data.education) ){
                    $scope.workHistoryData = angular.copy(data.workHistory);
                    $scope.educationHistoryData = angular.copy(data.education);
                    $scope.flags.loading = false;
                }
            };

            //reset edit form
            var resetForm = function() {
                $scope.addWorkHistory = false;
                $scope.addEducationHistory = false;
                $scope.workEditMode = false;
                $scope.educationEditMode = false;
                $scope.flags.loading = false;
                $scope.showRequiredFields = false;
                $scope.newWorkHistory = {};
                $scope.newEducationHistory = {};
                $scope.formValidation = {};
            };

            //cancel edit education/workHistory
            $scope.cancel = function(){
               profileFactory.getProfileHistoryData();
            };

            //show workHistory edit form
            $scope.enableWorkEdit = function(){
                $scope.workEditMode = true;
            };

            //show educationHistory edit form
            $scope.enableEducationEdit = function(){
                $scope.educationEditMode = true;
            };

            //add new workHistory
            $scope.addNewWorkHistory = function(){
                $scope.newWorkHistory = {};
                $scope.addWorkHistory = true;
            };

            //add new educationHistory
            $scope.addNewEducationHistory = function(){
                $scope.newEducationHistory = {};
                $scope.addEducationHistory = true;
            };

            //massage post data before posting
            var massagePostData = function(postData){
                //jacksonObjectMapper needs eid to be sent in lowercase
                angular.forEach(postData,function(postDataItem){
                    postDataItem.eid = angular.copy(postDataItem.EId);
                    delete postDataItem.EId;
                    //select2 gives back an object. Extract only values to be posted.
                    if(postDataItem.degreeType){
                        postDataItem.degreeType  =  postDataItem.degreeType.value;
                    }
                    if(postDataItem.startMonth ){
                        postDataItem.startMonth = (parseInt(postDataItem.startMonth.value) + 1);
                    }
                    if(postDataItem.startYear ){
                        postDataItem.startYear =  postDataItem.startYear.value;
                    }
                    if(postDataItem.endMonth){
                        postDataItem.endMonth =  (parseInt(postDataItem.endMonth.value) + 1);
                    }
                    if(postDataItem.endYear){
                        postDataItem.endYear =   postDataItem.endYear.value;
                    }
                });
                return postData;
            };

            //validate start date end dates
            var validateDateFields = function(startDate, endDate){

                var startDateMilli = moment(startDate, 'DD-MM-YYYY').unix()*1000;
                var endDateMilli = moment(endDate, 'DD-MM-YYYY').unix()*1000;

                return startDateMilli > endDateMilli;
            };

            function getMonthNumber(monthParam) {

                var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                //if monthParam is not set, set it to 01
                var month = months[parseInt(monthParam)] || '01';

                return String(month);
            }

            var validateWorkHistoryFields = function(postDataArr){
                var formValidation = {};

                for( var i = 0 ; i < postDataArr.length; i++){
                    formValidation[i] = {};
                    formValidation[i].invalidYears =  false;
                    formValidation[i].emptyRequiredFieldsWH =  false;
                    formValidation[i].emptyRequiredFieldsWH_startYear =  false;
                    formValidation[i].emptyRequiredFieldsWH_startMonth =  false;
                    formValidation[i].emptyRequiredFieldsWH_endYear =  false;
                    formValidation[i].emptyRequiredFieldsWH_endMonth =  false;


                    var postDataItem = postDataArr[i];

                    if(!postDataItem.companyName){
                        formValidation[i].emptyRequiredFieldsWH = true;
                        formValidation.emptyRequiredFieldsWH = true;
                    }

                    if(!postDataItem.startYear || !postDataItem.startYear.value) {
                         formValidation[i].emptyRequiredFieldsWH = true;
                         formValidation[i].emptyRequiredFieldsWH_startYear =  true;
                         formValidation.emptyRequiredFieldsWH = true;
                    }
                    if(!angular.isDefined(postDataItem.startMonth) || !postDataItem.startMonth.value) {
                         formValidation[i].emptyRequiredFieldsWH = true;
                         formValidation[i].emptyRequiredFieldsWH_startMonth =  true;
                         formValidation.emptyRequiredFieldsWH = true;
                    }
                    if(postDataItem.endYear && postDataItem.endYear.value && (!angular.isDefined(postDataItem.endMonth) || !postDataItem.endMonth.value)) {
                         formValidation[i].emptyRequiredFieldsWH_endMonth =  true;
                         formValidation[i].invalidYears = true;
                    }

                    if(angular.isDefined(postDataItem.endMonth) && postDataItem.endMonth.value && (!angular.isDefined(postDataItem.endYear) || !postDataItem.endYear.value)) {
                         formValidation[i].emptyRequiredFieldsWH_endYear =  true;
                         formValidation[i].invalidYears = true;
                    }

                    if(angular.isDefined(postDataItem.startMonth) && angular.isDefined(postDataItem.endMonth) && postDataItem.endMonth.value
                        && postDataItem.startYear && postDataItem.startYear.value
                        && postDataItem.endYear && postDataItem.endYear.value){
                        var startMonth = getMonthNumber(postDataItem.startMonth.value);
                        var endMonth = getMonthNumber(postDataItem.endMonth.value);

                        formValidation[i].invalidYears = false;

                        if(postDataItem.startYear && postDataItem.startYear.value && postDataItem.endYear && postDataItem.endYear.value){
                            var startDate = '01/'+startMonth+'/'+postDataItem.startYear.value;
                            var endDate = '01/'+endMonth+'/'+postDataItem.endYear.value;

                            formValidation[i].invalidYears = validateDateFields(startDate, endDate);
                        }
                    }

                    if(!formValidation.invalidYears){
                        formValidation.invalidYears = angular.copy(formValidation[i].invalidYears);
                    }
                }

                return formValidation;
            };

            $scope.degreeTypeMap = jvCandidateProfileFactory.degreeTypeMap;

            //save workHistory
            $scope.saveWorkHistory = function(){
                $scope.flags.loading = true;
                var args = {};

                //check if user is creating a new workHistory or updating an existing one
                if(!$.isEmptyObject($scope.newWorkHistory)){
                    args.postData = angular.copy([$scope.newWorkHistory]);
                }else{
                    args.postData = angular.copy($scope.workHistoryData);
                }
                $scope.formValidation = angular.copy(validateWorkHistoryFields(args.postData));
                if($scope.formValidation.invalidYears || $scope.formValidation.emptyRequiredFieldsWH){
                    $scope.flags.loading = false;
                    return false;
                }
                args.postData = massagePostData(args.postData);
                //save to  profileFactory
                profileFactory.saveWorkHistory(args);
            };

            //initialize month dropdown object
            $scope.monthPicker = {
                'textField': 'label',
                'idField': 'name',
                'label': i18n['SELECT_OPTION'] ,
                'placeHolder': i18n['SELECT_OPTION'] ,
                'values': angular.copy(months.formats.fullmonths)
            };

            //set how many years in the past you want in your drop down. Factory defaults to 10
            years.setRange(50);
            $scope.yearValues  = angular.copy(years.getYears());
            //initialize year dropdown object
            $scope.yearPicker = {
                'textField': 'label',
                'idField': 'name',
                'label': i18n['SELECT_OPTION'],
                'placeHolder': i18n['SELECT_OPTION'] ,
                'values': $scope.yearValues
            };
                        
            /*Validate education fields
                If user leaves the degree text box empty populate it with degreeType.name as it is a not null field
                Required fields are collegeName, degree , degreeType , degreeGrade
            */
            var validateEducationFields = function(postDataArr){
                var formValidation = {};
                for( var i = 0 ; i < postDataArr.length; i++){
                    
                    formValidation[i] = {};
                    formValidation[i].emptyRequiredFields = false;
                    formValidation[i].invalidDates =  false;
                    
                    var postDataItem = postDataArr[i];

                    if( ! $.isEmptyObject(postDataItem )) {

                        if(!postDataItem.collegeName){
                            formValidation[i].emptyRequiredFields = true;
                            formValidation.emptyRequiredFields = true;
                        }

                        //validate date fields
                        formValidation[i].invalidDates = validateDateFields(postDataItem.startDate, postDataItem.endDate);
                        if(!formValidation.invalidDates){
                            formValidation.invalidDates = angular.copy(formValidation[i].invalidDates);
                        }

                        /*set degreeGrade value to 0 as we dont want to surface this on the UI
                          FAILED(1, "failed"), PASS(2, "pass"), GOOD(3, "good"), EXCELLENT(4, "excellent");
                        */

                        postDataItem.degreeGrade = 0;

                        //if degree is not entered set it as degreeType.name
                        if(!postDataItem.degree){
                            postDataItem.degree = postDataItem.degreeType.name;
                        }

                        //if degreeType is selected populate degree
                        if( angular.isObject(postDataItem.degreeType)  && !postDataItem.degreeType.value){
                            formValidation[i].emptyRequiredFields = true;
                            formValidation.emptyRequiredFields = true;
                        }
                    }
                }
                return formValidation;
            };

            //save educationHistory
            $scope.saveEducationHistory = function(){
                $scope.flags.loading = true;

                $scope.formValidation = {};
                
                var args = {};
                //check if user is creating a new educationHistory or updating an existing one
                if(!$.isEmptyObject($scope.newEducationHistory)){
                    args.postData = angular.copy([$scope.newEducationHistory]);
                }else{
                    args.postData = angular.copy($scope.educationHistoryData);
                }

                $scope.formValidation = angular.copy(validateEducationFields(args.postData));
                
                if($scope.formValidation.emptyRequiredFields || $scope.formValidation.invalidDates){
                    $scope.flags.loading = false;
                    return false;
                }

                args.postData = massagePostData(args.postData);
                //save to  profileFactory
                profileFactory.saveEducationHistory(args);
            };
            

            //register all subscribers to the profile object that need to get called when profile gets updated
            if($scope.perms.CANDIDATE_DETAILS_GET) {
                profileFactory.profile.data = null;
                profileFactory.profile.fetchInProgress = false;
                profileFactory.registerSubscribers([resetForm, renderProfileHistoryData]);
            }

            //registering candidate details page as subscriber
            $scope.$on('getProfileHistory', function(event, eventData) {
                profileFactory.registerSubscribers(eventData.subscriber);
                profileFactory.getProfileHistoryData({applicationId: $routeParams.applicationId, canGetWorkAndEducationHistory: $scope.perms.APPLICATION_APPLICATIONS_APP_DETAILS_GET});
            });
            
            //event handler to put workHistory section in editmode when edit is clicked from identity module
            $scope.$on('editWorkHistory', function(event) {
                if(event){
                    //click edit on identity while on some other tab
                    var isSummaryTab = $scope.activeTab('summary');
                    if(!isSummaryTab){
                        $window.location.hash = '#/summary/'+$routeParams.applicationId;
                            var evtData = {
                                elem: '#jvt-workHistory',
                                mode: 'workEditMode'
                            };
                            $scope.$broadcast('scrollToProfileHistoryEdit',evtData);
                    }else{
                        var top = $('#jvt-workHistory').offset().top;
                        $('html,body').animate({ scrollTop: top }, 400);
                        $scope.workEditMode = true;
                    }
                    
                }
            });

             //event handler to put education section in editmode when edit is clicked from identity module
            $scope.$on('editEducationHistory', function(event) {
                if(event){
                    //click edit on identity while on some other tab
                    var isSummaryTab = $scope.activeTab('summary');
                    if(!isSummaryTab){
                        var evtData = {
                                elem: '#jvt-educationHistory',
                                mode: 'educationEditMode'
                            };
                        $scope.$broadcast('scrollToProfileHistoryEdit',evtData);
                        $window.location.hash = '#/summary/'+$routeParams.applicationId;
                    }else{
                        var top = $('#jvt-educationHistory').offset().top;
                        $('html,body').animate({ scrollTop: top }, 400);
                        $scope.educationEditMode = true;
                    }
                }
            });

            //scroll to workhistory / education history section when edit is clicked from identity while user is on a different tab other than summary
            $scope.$on('scrollToProfileHistoryEdit',function(event,data){
                profileFactory.getProfileHistoryData({applicationId: $routeParams.applicationId, canGetWorkAndEducationHistory: $scope.perms.APPLICATION_APPLICATIONS_APP_DETAILS_GET},function(){
                    var top = $(data.elem).offset().top;
                    $('html,body').animate({ scrollTop: top }, 400);
                        if(data.mode){
                            //Need to find why calling $scope.enableWorkEdit doesnt work
                            $timeout(function(){
                                $('#'+data.mode).click();
                                //$scope.enableWorkEdit();
                            },500);
                        }
                });
            });
            $scope.$emit('profileCtrlLoaded');

            $scope.$on('permissions_updated', function(){
                $scope.canEditProfile = $scope.perms.APPLICATION_APPLICATIONS_DETAILS_EDIT_POST || false;
            });
        }
]);
